import http from '~/common/http'


function undo(params){ //撤销操作
    return http.post('/api/approve/undo',params);
}



//获取我发起的审批列表
function sendApprove(params){
    return http.get('/api/approve/index', {
        params: params
    });
}

//待我审批列表
function todo(params){
    return http.get('/api/approve/todo', {
        params: params
    });
}
function copyToMe(params){
    return http.get('/api/approve/copy-to-me', {
        params: params
    });
}
function approve(params)
{
    return http.post('/api/approve/do-check',params);
}
export default {
    sendApprove,
    todo,
    approve,
    undo,
    copyToMe
}


// WEBPACK FOOTER //
// ./src/services/approve.js